export const CHART_COLOR_PALETTE = ["#8884d8", "#82ca9d", "#ff7300"];

export const MEASURE_COLOR_PALETTE = {
  soil_moisture: "#8884d8",
  soil_temperature: "#82ca9d",
  soil_electrical_conductivity: "#ff7300",
  air_temperature: "#ffc658",
  air_humidity: "#8dd1e1",
  illuminance: "#d084d8",
  pressure: "#4e79a7",
  wind_direction: "#b07aa1",
  wind_speed: "#59a14f",
  rain_intensity: "#76b7b2",
  global_solar_radiation: "#edc948",
  sunshine_duration: "#f28e2b",
  default: "grey",
};

export const MEASURE_CURRENT_COLOR_PALETTE = {
  moisture: "#8884d8",
  temperature: "#82ca9d",
  soil_ec: "#ff7300",
  default: "grey",
};

export const CHIP_COLOR_OPACITY = "20";

export const CHART_DIMENSIONS = {
  height: 300,
  xAxisHeight: 80,
  xAxisAngle: -45,
  maxHeight: 100,
};

export const DATE_FORMAT = "DD/MM HH:mm";

export const CHART_GRID = {
  strokeDasharray: "3 3",
};

export const CHART_LINE_CONFIG = {
  type: "monotone",
  dot: true,
  activeDot: { r: 6 },
  strokeWidth: 2,
  connectNulls: true,
};

export const AVERAGE_LINE_CONFIG = {
  ...CHART_LINE_CONFIG,
  strokeDasharray: "5 5",
};

export const getMeasureColor = (
  measureKey,
  isCurrent,
  selectedMeasures = []
) => {
  if (isCurrent && selectedMeasures.length > 0) {
    const index = selectedMeasures.indexOf(measureKey);

    if (index !== -1) {
      return CHART_COLOR_PALETTE[index % CHART_COLOR_PALETTE.length];
    }

    return MEASURE_CURRENT_COLOR_PALETTE.default;
  }
  return MEASURE_COLOR_PALETTE[measureKey] || MEASURE_COLOR_PALETTE.default;
};

export const getChipBackgroundColor = (color) => {
  if (!color || typeof color !== "string") {
    return `${CHART_COLOR_PALETTE[0]}${CHIP_COLOR_OPACITY}`;
  }
  return `${color}${CHIP_COLOR_OPACITY}`;
};

export const getYAxisConfig = (measureKey, index, color, unit) => ({
  yAxisId: measureKey,
  orientation: index % 2 === 0 ? "left" : "right",
  stroke: color,
  ...(unit ? { unit, width: Math.max(80, 56 + unit.length * 8) } : {}),
});

export const getLineConfig = (measureKey, label, color, isAverage = false) => ({
  ...(isAverage ? AVERAGE_LINE_CONFIG : CHART_LINE_CONFIG),
  dataKey: measureKey,
  stroke: color,
  name: label,
  yAxisId: measureKey,
});
